import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Phone, MapPin, ExternalLink, Search, Check } from 'lucide-react';

const referralCategories = [
  {
    title: "Dermatologer (Hudlæger)",
    items: [
      { name: "Ida-Marie Stender", address: "Hans Edv Teglers Vej 9, 1, 2920 Charlottenlund", phone: "39 63 11 82" },
      { name: "Søren Kamp", address: "Lyngby Hovedgade 27, 2800 Kgs. Lyngby", phone: "45 88 01 77" },
      { name: "Hudklinikken Panoptikon", address: "Banegårdspladsen 1, 5., 1570 København V", phone: "33 12 22 20" },
      { name: "Louise Arup Fischer Neergaard", address: "H.C. Ørsteds Vej 1A, 1879 Frederiksberg C", phone: "33 31 30 66" },
      { name: "Ane Marie Ahm Petersen og Josefine Bandier", address: "Trianglen 4, 1., th., 2100 København Ø", phone: "39 62 86 21" },
      { name: "David Mølenberg", address: "Linnésgade 24, 1, 1361 København K", phone: "33 13 21 13" },
    ]
  },
  {
    title: "Gas.kir – Kirurger",
    items: [
      { name: "Bahir Hadi", address: "Hans Edv Teglers Vej 9, 1, 2920 Charlottenlund", phone: "39 64 01 25", url: "kirurgen.dk" },
      { name: "Oline Larsen Langballe", address: "Jægersborg Alle 16, 1, 2920 Charlottenlund", phone: "39 64 14 80", url: "kirurg-charlottenlund.dk" },
      { name: "Jan Struckmann", address: "Lyngby Hovedgade 64, 1., 2800 Kgs. Lyngby", phone: "45 87 40 08", url: "struckmannsklinik.dk" },
      { name: "Rolf Nielsen (Sankt Lukas Stiftelsen)", address: "Sankt Lukas Vej 7 B, 2900 Hellerup", phone: "23 71 90 51", url: "rolfnielsen.dk" },
    ]
  },
  {
    title: "Gas.med – Mavetarmmedicinere",
    items: [
      { name: "Søren Kiilerich", address: "Dronningens Tværgade 30, 4, 1302 København K", phone: "33 11 31 79", url: "kiilerich-klinikken.dk" },
      { name: "Jimmy Collemorten", address: "Skt. Kjelds Plads 12, 1, 2100 København Ø", phone: "44 95 68 23", url: "mavelægerne.dk" },
      { name: "Anne Birgitte Haaber", address: "Jægersborg Alle 16, 2., 2920 Charlottenlund", phone: "72 13 60 00", url: "mavespecialisten.dk" },
    ]
  },
  {
    title: "Plastikkirurger",
    items: [
      { name: "Anders Peter Andersson", address: "Søndre Fasanvej 90, 1., tv, 2500 Valby", phone: "36 46 05 07" },
      { name: "Kirsten Hviid Alsbjørn", address: "Lyngby Hovedgade 57 B, 1., 2800 Kgs. Lyngby", phone: "45 87 45 33", url: "lyngbyplastik.dk" },
    ]
  },
  {
    title: "Pædiater (Børnelæge)",
    items: [
      { name: "Børnelægeklinikken", address: "Poul Ankers Gade 2, st, th, 1271 København K", phone: "24 20 02 13", url: "børnedoktor.dk" },
      { name: "Lise Lykke Thomsen (Neuropædiater)", address: "Jægersborgvej 66A, 1., 2800 Kgs. Lyngby", phone: "45 93 28 98", url: "lise-lykke-thomsen.dk" },
      { name: "Ida Norgil (Astma)", address: "Kirkegårdsvej 25A, 1, 2300 København S", phone: "38 87 18 48", url: "idanorgil.dk" },
      { name: "Søren Fangel (Børneurolog/Børnemavetarm)", address: "Vestergade 21, 1., 4600 Køge", phone: "56 65 12 33", url: "boernepraksis.dk" },
    ]
  },
  {
    title: "Øjenlæger",
    items: [
      { name: "Nathalie Zibrandtsen", address: "Strandvejen 102B, 2, 2900 Hellerup", phone: "82 82 02 00", url: "oejne.dk" },
      { name: "Vaida Havemose", address: "Willemoesgade 18, st, tv, 2100 København Ø", phone: "35 26 18 90" },
      { name: "Københavns Øjenklinik i Lyngby", address: "Jægersborgvej 66A, 1, 2800 Kgs. Lyngby", phone: "69 16 10 66", url: "cpheyeclinic.dk" },
      { name: "Øjenlægernes Hus ApS", address: "Store Kannikestræde 16, 1169 København K", phone: "70 22 12 32", url: "privatojenlage.dk" },
      { name: "Carsten Øgard", address: "Jernbanevej 2, 1, 3520 Farum", phone: "44 95 12 13", url: "øjenklinikken.com" },
      { name: "Soheila Naftchi", address: "Østerbrogade 196, 5, 2100 København Ø", phone: "29 17 67 46", url: "osterbro-ojenklinik.dk" },
    ]
  },
  {
    title: "Psykologer",
    items: [
      { name: "Anne-Sophie B. Hornbech (Privat)", address: "Bengtasvej 10, 2900 Hellerup", phone: "20 26 75 61", url: "as-hornbech.dk" },
      { name: "Anette Blicher (Med tilskud)", address: "Jægersborg Alle 19, 2920 Charlottenlund", phone: "20 42 98 62", url: "anetteblicher.dk" },
      { name: "Kognitiv Center København (Privat)", address: "Nørregade 7a, 1165 København K", phone: "23 60 98 00" },
    ]
  },
  {
    title: "Gynækologer",
    items: [
      { name: "Thue Bryndorf", address: "Ny Østergade 10, 3, tv, 1101 København K", phone: "33 15 14 13", url: "bryndorf.dk" },
      { name: "Maria Isabel de la Fuente Fonnest", address: "Classensgade 3A, 5., 2100 København Ø", phone: "35 42 43 49" },
      { name: "Tine Tetzschner", address: "Axeltorv 8 , 5, 1609 København V", phone: "33 33 95 15", url: "tinesklinik.dk" },
      { name: "Anne Høyrup Bjerre", address: "Gentoftegade 39, 1, 2820 Gentofte", phone: "39 65 2000", url: "gentoftegyn.dk" },
      { name: "Lars Alling Møller", address: "Bernstorffsvej 20 C, 3, 2900 Hellerup", phone: "21 95 40 40", url: "larsalling.dk" },
      { name: "Kirsten Pilsgaard", address: "Hyskenstræde 10, 1207 København K", phone: "33 14 89 49", url: "city-gyn.dk" },
      { name: "Priya Ajay Chauhan", address: "Rungsted Bytorv 1, 2960 Rungsted Kyst", phone: "48 17 62 50", url: "gynaekolog.dk" },
    ]
  },
  {
    title: "Kardiologer (Hjertelæger)",
    items: [
      { name: "Jens Hove", address: "Brogårdsvænget 4, st, 2820 Gentofte", phone: "45 82 29 81", url: "hjerte-lægen.dk" },
      { name: "Carsten Toftager Larsen", address: "Amaliegade 26, 1256 København K", phone: "33 15 14 19", url: "hjerteklinikkenamaliegade.dk" },
      { name: "Speciallæge Henrik Nielsen", address: "Holte Midtpunkt 23, 3, 2840 Holte", phone: "45 42 44 42" },
      { name: "Bente Kühn Madsen, Søren Galatius", address: "Østerbrogade 62, 1., 2100 København Ø", phone: "35 38 7828" },
    ]
  },
  {
    title: "Lungemediciner",
    items: [
      { name: "Henriette Enevoldsen", address: "Hans Edv Teglers Vej 9, 1, 2920 Charlottenlund", phone: "39 62 21 20" },
    ]
  },
  {
    title: "Neurologer",
    items: [
      { name: "Tina Dysgaard", address: "Jægersborg Alle 14, 2, 2920 Charlottenlund", phone: "31 26 1261" },
    ]
  },
  {
    title: "Ortopædkirurger",
    items: [
      { name: "Anders W. Paulsen", address: "Bernstorffsvej 20, 3, 2900 Hellerup", phone: "39 18 5570" },
    ]
  },
  {
    title: "Psykiatere",
    items: [
      { name: "Mogens Undèn og Klaus Juul Martiny", address: "Falkoner Alle 112, 2000 Frederiksberg", phone: "35 37 37 21" },
      { name: "Jette LaBianca", address: "Engelsborgvej 38, 1, 2800 Kgs. Lyngby", phone: "44 66 86 60" },
      { name: "Ejnar Bundgaard Larsen", address: "Søborg Hovedgade 199, 3., 2860 Søborg", phone: "21 95 51 11" },
    ]
  },
  {
    title: "Reumatolog (Gigtlæge)",
    items: [
      { name: "Mette Klarlund", address: "Jægersborg Alle 16, 2, tv, 2920 Charlottenlund", phone: "39 63 6610" },
      { name: "Lillan Tobin", address: "Peter Bangs Vej 7A, op, 9, 2000 Frederiksberg", phone: "42 43 0610" },
    ]
  },
  {
    title: "Røntgen",
    items: [
      { name: "I/S Røntgenklinikken", address: "Trianglen 5, 2100 København Ø", phone: "35 26 71 06" },
      { name: "Frederiksstadens Røntgen og Ultralyd", address: "Store Kongensgade 90A, 1264 København K", phone: "33 13 43 26" },
    ]
  },
  {
    title: "Øre/Næse/Hals-læger",
    items: [
      { name: "Anders Schermacher Larsen", address: "Lyngbyvej 317, 2820 Gentofte", phone: "69 65 15 39" },
      { name: "Øre-Næse-Halsklinik i Charlottenlund", address: "Jægersborg Alle 4, 3.sal, 2920 Charlottenlund", phone: "44 98 19 21" },
      { name: "Øre-Næse-Halsklinik v/Stefan Astorri", address: "Jægersborg Alle 19, 2920 Charlottenlund", phone: "39 64 29 04" },
      { name: "Christian Prætorius / Ronald Welander", address: "Kongevejs-Centret 6, 1, 2970 Hørsholm", phone: "45 86 46 00" },
      { name: "Bettina Berner", address: "Søborg Hovedgade 93, 2860 Søborg", phone: "39 56 09 09" },
      { name: "Niels R. Christensen og Niels Wagner", address: "Søndre Strandvej 10 , st, 3000 Helsingør", phone: "49 21 53 00" },
      { name: "Hans Ulrik Kjærem", address: "Østergade 18, 4, 1100 København K", phone: "32 22 6660" },
      { name: "Mads Sølling Fynboe", address: "Købmagergade 67, 3, tv, 1150 København K", phone: "33 13 2648" },
    ]
  }
];

export default function Referrals() {
  return (
    <main className="pb-24">
      <Helmet>
        <title>Henvisninger | Hellerup Lægehus</title>
      </Helmet>

      {/* Hero Section */}
      <section className="bg-slate-50 pt-32 pb-20 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <div className="flex items-center gap-4 mb-6">
              <div className="h-[1px] w-12 bg-[#4b717a]" />
              <span className="text-[#4b717a] text-xs tracking-[0.4em] uppercase font-bold">Information</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-sans font-medium text-black mb-8 leading-tight tracking-tight">
              Henvisninger til speciallæger og andre behandlere
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed mb-8">
              Du kan selv uden henvisning kontakte en øre,næse,hals-læge, en øjenlæge eller en kiropraktor. 
              Før der eventuelt kan laves en henvisning til en speciallæge, psykolog eller fysioterapeut 
              ønsker vi at se jer til en læge-konsultation for at sikre os, at du får den rette behandling.
            </p>
            <a 
              href="https://www.sundhed.dk/borger/find-behandler/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#4b717a] text-white px-8 py-4 font-bold tracking-widest uppercase text-xs hover:bg-[#3d5c64] transition-colors"
            >
              <Search className="w-4 h-4" />
              Søg selv efter en behandler på Sundhed.dk
            </a>
          </div>
        </div>
      </section>

      {/* Insurance Info */}
      <section className="py-16 bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div className="bg-[#4b717a] text-white p-10">
              <h2 className="text-2xl font-sans font-medium mb-6">Private sundhedsforsikringer</h2>
              <div className="space-y-4 text-white/90 leading-relaxed">
                <p>
                  Hvis du vil benytte din sundhedsforsikring, skal det oplyses til lægen, der udfærdiger henvisningen. 
                  Sundhedsforsikringen skal primært bruges til henvisninger, som kunne have været udført i offentligt regi.
                </p>
                <p>
                  Ønskes henvisning til ydelser, der ikke tilbydes via den offentlige sygesikring, arbejder den praktiserende læge ikke længere for sygesikringen, men privat.
                </p>
                <p className="text-sm italic border-l-2 border-white/30 pl-4">
                  Anmodning om vurdering og eventuelt henvisning vil normalt skulle foreligge fra forsikringsselskabet inden konsultationen.
                </p>
              </div>
            </div>
            <div className="pt-4">
              <h3 className="text-xl font-sans font-medium text-black mb-4">Eksempler på private ydelser:</h3>
              <ul className="space-y-3">
                {["Psykologhjælp (ikke omfattet af sygesikringen)", "Kiropraktor", "Akupunktur"].map((item, idx) => (
                  <li key={idx} className="flex items-center gap-3 text-slate-600">
                    <Check className="w-4 h-4 text-black" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Specialist List */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-sans font-medium text-black mb-12">Speciallægeliste</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {referralCategories.map((category, idx) => (
              <div key={idx} className="bg-slate-50 p-8 border border-slate-200 flex flex-col">
                <h3 className="text-lg font-bold text-[#4b717a] mb-6 tracking-wide uppercase text-sm border-b border-slate-200 pb-4">
                  {category.title}
                </h3>
                <div className="space-y-8 flex-grow">
                  {category.items.map((item, itemIdx) => (
                    <div key={itemIdx} className="group">
                      <h4 className="font-sans font-medium text-black mb-2 group-hover:text-black transition-colors">
                        {item.name}
                      </h4>
                      <div className="space-y-2 text-sm text-slate-600">
                        <div className="flex items-start gap-2">
                          <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-slate-400" />
                          <span>{item.address}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Phone className="w-4 h-4 flex-shrink-0 text-slate-400" />
                          <a href={`tel:${item.phone.replace(/\s/g, '')}`} className="hover:text-[#4b717a] hover:underline">
                            {item.phone}
                          </a>
                        </div>
                        {item.url && (
                          <div className="flex items-center gap-2 pt-1">
                            <ExternalLink className="w-4 h-4 flex-shrink-0 text-slate-400" />
                            <a 
                              href={`https://${item.url}`} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="text-[#4b717a] hover:underline font-medium"
                            >
                              {item.url}
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
